module.exports = __webpack_public_path__ + "static/img/default-role-avator.b9216f6c.png";